import { render } from "./ver-facturas.vue?vue&type=template&id=4dd5df92&scoped=true"
import script from "./ver-facturas.vue?vue&type=script&lang=js"
export * from "./ver-facturas.vue?vue&type=script&lang=js"

import "./ver-facturas.vue?vue&type=style&index=0&id=4dd5df92&scoped=true&lang=css"
import "./ver-facturas.vue?vue&type=style&index=1&id=4dd5df92&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd5df92"]])

export default __exports__